/**
 * <ry-alert>
 *
 * Alert message component.
 *
 * Usage:
 * <ry-alert>Default info alert</ry-alert>
 * <ry-alert variant="success">Success!</ry-alert>
 * <ry-alert variant="warning" dismissible>Warning with close button</ry-alert>
 *
 * JS uses data-ry-target for queries, CSS uses classes for styling.
 */

import { RyElement } from '../core/ry-element.js';

export class RyAlert extends RyElement {
  setup(): void {
    // Transform minimal markup
    this.#transformMarkup();

    // Dismissible (use [close] attribute)
    const closeBtn = this.$('[close]');
    if (closeBtn) {
      this.on(closeBtn, 'click', () => this.dismiss());
    }
  }

  #transformMarkup(): void {
    // Check if already transformed
    if (this.$('[data-ry-target="content"]')) return;

    const variant = this.getAttribute('variant') ?? 'info';
    const dismissible = this.hasAttribute('dismissible');
    const content = this.innerHTML;

    // data-ry-target for JS queries, class for CSS styling
    this.innerHTML = `
      <div data-ry-target="content" class="ry-alert__content">${content}</div>
      ${dismissible ? '<button data-ry-target="close" class="ry-alert__close" close aria-label="Dismiss">&times;</button>' : ''}
    `;

    this.setAttribute('role', 'alert');
    this.setAttribute('data-variant', variant);
  }

  dismiss(): void {
    this.state = 'closed';

    // Remove after animation
    setTimeout(() => {
      this.remove();
    }, 200);

    this.emit('close');
  }
}

customElements.define('ry-alert', RyAlert);
